import { apiFetch } from './client';
import type { Me } from '$lib/types';

export const fetchMe = () => apiFetch<Me>('/me');
